// extracted by mini-css-extract-plugin
var _1 = "jN4mg";
export { _1 as "jobStatus" }
